<template>
  <div>
    <h4 class="primaryText--text mb-2">Siste prosjekter</h4>
    <ProjCards
      v-model="projects"
      :fullWidth="fullWidth"
      :loading="loading"
      @click="goToProject"
    >
      <template v-slot:btn="{ project }">
        <v-icon class="closeBtn" @click.stop="confirmDeleteFromList(project)">
          mdi-close-circle
        </v-icon>
      </template>
    </ProjCards>

    <ConfirmDialog
      v-model="showConfirmDeactivate"
      title="Bekreft"
      icon="mdi-office-building-outline"
      :text="`Er du sikker på at du vil slette ${saveProject.name} fra siste prosjekt listen?`"
      btnActionName="Bekreft"
      @action="deleteFromList(saveProject)"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import projectApi from "@/api/projectApi";
import contactpersonApi from "@/api/contactpersonApi";
import { mapGetters } from "vuex";
import { projectObject } from "@/types/projectInterface";

import ProjCards from "@/components/projects/children/ProjCards.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";

export default Vue.extend({
  name: "DashboardServices",
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      projects: [] as Array<projectObject>,
      showConfirmDeactivate: false,
      saveProject: {} as projectObject,
    };
  },
  async mounted() {
    this.getProjects();
  },
  watch: {
    async checkedIn(value) {
      if (value.isCheckedIn) {
        this.projects.forEach((x) => {
          if (value.projects.some((y) => y.id === x.id)) {
            x.checkedIn = true;
          }
        });
      } else {
        this.projects.forEach((x) => {
          x.checkedIn = false;
        });
      }
    },
  },
  methods: {
    goToProject(project) {
      this.$router.push({ name: "Project", params: { id: project.id } });
    },
    async getProjects() {
      this.loading = true;

      let psiAgreementKey = [];
      await contactpersonApi.getUserSetting("psiAgreement").then((response) => {
        psiAgreementKey = response;
      });

      await projectApi.getRecentProjects(6).then((resp) => {
        this.projects = resp.projects;
        this.projects.forEach((x) => {
          var psiAgreement = psiAgreementKey[x.id] as any;
          if (psiAgreement && psiAgreement.confirm) {
            x.psiConfirmed = psiAgreement.confirm;
          }
        });

        this.getProjectImage(this.projects);
        this.loading = false;
      });
    },
    getProjectImage(projects: Array<projectObject>) {
      projects.forEach((x) => {
        projectApi.getProjectImage(x.id).then((resp) => {
          this.$set(
            x,
            "defaultImage",
            "data:" + resp.contentType + ";base64," + resp.image
          );
        });
      });
    },
    confirmDeleteFromList(project: projectObject) {
      this.saveProject = project;
      this.showConfirmDeactivate = true;
    },
    async deleteFromList(project: projectObject) {
      await projectApi.deleteRecentProject(project.id).then(() => {
        this.showConfirmDeactivate = false;
        this.projects = this.projects.filter((x) => x.id !== project.id);
      });
    },
  },

  computed: {
    ...mapGetters({
      checkedIn: "shared/checkedIn",
    }),
  },
  components: {
    ProjCards,
    ConfirmDialog,
  },
});
</script>

<style lang="scss" scoped>
.closeBtn {
  top: 5px !important;
  right: 10px !important;
  position: absolute;
}
</style>
